import { travel } from 'api';

import { TravelForCustomerSupport } from 'models/customerSupport';
import { Response } from 'models/response';

export interface EmailRequest {
  description: string;
}

export interface CancelTravelRequest {
  travelId: string;
  reason?: string;
}

export interface GetTravelsForCustomerSupportRequest {
  userId: string;
  pageNumber: number;
  pageSize: number;
}

export interface GetTravelsForCustomerSupportResponse {
  totalCount: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
  travels: TravelForCustomerSupport[];
}

export const sendEmail = (data: EmailRequest): Promise<void> =>
  travel.post<void>('CustomerSupport/Email', data).then((response) => response.data);

export const cancelTravel = ({ travelId, reason = 'Cancelled by user' }: CancelTravelRequest): Promise<void> =>
  travel
    .put<void>(`CustomerSupport/Travel/Cancel/${travelId}`, { reason })
    .then((response) => response.data);

export const getTravels = (params: GetTravelsForCustomerSupportRequest) =>
  travel
    .get<Response<GetTravelsForCustomerSupportResponse>>('Travels/GetTravelsForCustomerSupport', { params })
    .then((r) => r.data);
